import EditableItem from './EditableItem';
import TiresForm from './TiresForm';

export default {
  EditableItem,
  TiresForm
};
